<template>
    <div>
        <top class="navs"></top>
        <navC :class="{ 'fix-nav': navFixed }"></navC>
        <router-view></router-view>
        <model></model>
        <footerC></footerC>
        <login-entry />
    </div>
</template>

<script>
import top from "./components/top.vue";
import navC from "./components/nav.vue";
import footerC from "./components/footer";
import loginEntry from './components/login-entry.vue';
export default {
    components: {
        top,
        navC,
        footerC,
        loginEntry
    },
    data() {
        return {
            navFixed: false,
        };
    },
    mounted() {
        // 事件监听滚动条
        // window.removeEventListener("scroll",this.watchScroll);
        window.addEventListener("scroll", this.watchScroll);
    },
    destroyed() {
        // 移除事件监听
        window.removeEventListener("scroll", this.watchScroll);
    },
    methods: {
        watchScroll() {
            // 滚动的距离
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            // 容器的高度
            var offsetTop = document.querySelector(".navs").offsetHeight;
            //  滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
            if (scrollTop > offsetTop) {
                GMS.vbus.$emit("change-color", { state: false });
                this.navFixed = true;
            } else {
                GMS.vbus.$emit("change-color", { state: true });
                this.navFixed = false;
            }
        },
    }
};
</script>

<style lang="less" scoped>
.fix-nav {
    position: sticky;
    top: 0;
    z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/portalNormal.vue